import React, { useState, useEffect } from 'react';
import { useLang } from './LangContext';

const texts = {
  it: {
    title: 'Questo sito utilizza i cookie',
    desc: 'Utilizziamo cookie tecnici necessari al funzionamento del sito e cookie analitici per migliorare la tua esperienza. Puoi accettare tutti i cookie o gestire le tue preferenze.',
    accept: 'Accetta tutti',
    reject: 'Solo necessari',
    preferences: 'Gestisci preferenze',
    necessary: 'Cookie necessari',
    necessaryDesc: 'Necessari per il funzionamento del sito. Non possono essere disattivati.',
    analytics: 'Cookie analitici',
    analyticsDesc: 'Ci aiutano a capire come utilizzi il sito per migliorare la tua esperienza.',
    marketing: 'Cookie di marketing',
    marketingDesc: 'Utilizzati per mostrarti annunci pertinenti ai tuoi interessi.',
    save: 'Salva preferenze',
    policy: 'Privacy Policy'
  },
  en: {
    title: 'This site uses cookies',
    desc: 'We use necessary technical cookies for site functionality and analytical cookies to improve your experience. You can accept all cookies or manage your preferences.',
    accept: 'Accept all',
    reject: 'Necessary only',
    preferences: 'Manage preferences',
    necessary: 'Necessary cookies',
    necessaryDesc: 'Required for the site to function. Cannot be disabled.',
    analytics: 'Analytics cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    marketing: 'Marketing cookies',
    marketingDesc: 'Used to show you ads relevant to your interests.',
    save: 'Save preferences',
    policy: 'Privacy Policy'
  }
};

export default function CookieBanner() {
  const { lang } = useLang();
  const t = texts[lang] || texts.it;
  const [visible, setVisible] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: false, marketing: false });

  useEffect(() => {
    const consent = localStorage.getItem('bonsai_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = (type) => {
    const consent = type === 'all'
      ? { necessary: true, analytics: true, marketing: true }
      : type === 'necessary'
        ? { necessary: true, analytics: false, marketing: false }
        : { necessary: true, ...prefs };
    localStorage.setItem('bonsai_cookie_consent', JSON.stringify(consent));
    localStorage.setItem('bonsai_cookie_date', new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-banner__inner">
        {!showPrefs ? (
          <>
            <div className="cookie-banner__content">
              <div className="d-flex align-items-center gap-2 mb-2">
                <i className="bi bi-shield-check text-success fs-5"></i>
                <h6 className="fw-bold mb-0">{t.title}</h6>
              </div>
              <p className="small mb-0 text-white-50">{t.desc}</p>
            </div>
            <div className="cookie-banner__actions">
              <button className="btn btn-success btn-sm" onClick={() => accept('all')} data-testid="cookie-accept-all">{t.accept}</button>
              <button className="btn btn-outline-light btn-sm" onClick={() => accept('necessary')} data-testid="cookie-reject">{t.reject}</button>
              <button className="btn btn-link btn-sm text-white-50 text-decoration-none" onClick={() => setShowPrefs(true)} data-testid="cookie-preferences">{t.preferences}</button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-banner__content">
              <h6 className="fw-bold mb-3">{t.preferences}</h6>
              <div className="cookie-pref-item mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div><strong className="small">{t.necessary}</strong><p className="small text-white-50 mb-0">{t.necessaryDesc}</p></div>
                  <div className="form-check form-switch"><input className="form-check-input" type="checkbox" checked disabled /></div>
                </div>
              </div>
              <div className="cookie-pref-item mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div><strong className="small">{t.analytics}</strong><p className="small text-white-50 mb-0">{t.analyticsDesc}</p></div>
                  <div className="form-check form-switch"><input className="form-check-input" type="checkbox" checked={prefs.analytics} onChange={e => setPrefs({...prefs, analytics: e.target.checked})} /></div>
                </div>
              </div>
              <div className="cookie-pref-item mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div><strong className="small">{t.marketing}</strong><p className="small text-white-50 mb-0">{t.marketingDesc}</p></div>
                  <div className="form-check form-switch"><input className="form-check-input" type="checkbox" checked={prefs.marketing} onChange={e => setPrefs({...prefs, marketing: e.target.checked})} /></div>
                </div>
              </div>
            </div>
            <div className="cookie-banner__actions">
              <button className="btn btn-success btn-sm" onClick={() => accept('custom')} data-testid="cookie-save-prefs">{t.save}</button>
              <button className="btn btn-outline-light btn-sm" onClick={() => setShowPrefs(false)}>
                <i className="bi bi-arrow-left me-1"></i>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
